const Domain = "https://billing.intelemedhealthcaresolutions.com/Api";
// const Domain = "http://localhost/THS_billing/telemeheath-Api";

export { Domain };
// http://rahulrajrahu33.pythonanywhere.com/
// https://www.marygiricollegebackend.xyz
//https://adtjcs.in/jyothi_HostelApp
